import { render, staticRenderFns } from "./UserPointsRecordDialog.vue?vue&type=template&id=147428f4&scoped=true&lang=pug&"
import script from "./UserPointsRecordDialog.vue?vue&type=script&lang=ts&"
export * from "./UserPointsRecordDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserPointsRecordDialog.vue?vue&type=style&index=0&id=147428f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147428f4",
  null
  
)

export default component.exports